export default "__VITE_ASSET__B$bZ2RIR__"